import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
    getAuth,
    setPersistence,
    browserLocalPersistence,
} from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_KEY,
    authDomain: "pawport-e8efe.firebaseapp.com",
    projectId: "pawport-e8efe",
    storageBucket: "pawport-e8efe.appspot.com",
    messagingSenderId: "97168657",
    appId: "1:97168657:web:7ccd950a2abd813a85b0b0",
    measurementId: "G-CEW8P3PJVK",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

setPersistence(auth, browserLocalPersistence)
    .then(() => {
        console.log("Persistence set to local");
    })
    .catch((error) => {
        console.error("Failed to set persistence:", error);
    });
